var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSirenButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon/siren"
  }, /*#__PURE__*/React.createElement("g", {
    id: "siren"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_405_1076",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.891602,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_405_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "siren_2",
    d: "M4.6155 19.8916H19.3845C19.564 19.8916 19.7115 19.8339 19.827 19.7186C19.9423 19.6031 20 19.4556 20 19.2761V17.7571C20 17.5776 19.9423 17.4301 19.827 17.3146C19.7115 17.1993 19.564 17.1416 19.3845 17.1416H4.6155C4.436 17.1416 4.2885 17.1993 4.173 17.3146C4.05767 17.4301 4 17.5776 4 17.7571V19.2761C4 19.4556 4.05767 19.6031 4.173 19.7186C4.2885 19.8339 4.436 19.8916 4.6155 19.8916ZM8.673 13.8339H9.673V11.0261C9.673 10.3916 9.90083 9.84835 10.3565 9.39635C10.8123 8.94452 11.3602 8.7186 12 8.7186V7.7186C11.0795 7.7186 10.2949 8.03977 9.64625 8.6821C8.99742 9.32427 8.673 10.1056 8.673 11.0261V13.8339ZM6.827 16.1416H17.173V11.0261C17.173 9.5916 16.6683 8.37719 15.659 7.38285C14.6495 6.38869 13.4287 5.8916 11.9965 5.8916C10.5642 5.8916 9.3445 6.38869 8.3375 7.38285C7.3305 8.37719 6.827 9.5916 6.827 11.0261V16.1416ZM4.6155 20.8916C4.17117 20.8916 3.79083 20.7334 3.4745 20.4171C3.15817 20.1008 3 19.7204 3 19.2761V17.7571C3 17.3128 3.15817 16.9324 3.4745 16.6161C3.79083 16.2998 4.17117 16.1416 4.6155 16.1416H5.827V11.0261C5.827 9.31727 6.42583 7.8676 7.6235 6.6771C8.82133 5.48677 10.28 4.8916 11.9995 4.8916C13.719 4.8916 15.1778 5.48677 16.376 6.6771C17.574 7.8676 18.173 9.31727 18.173 11.0261V16.1416H19.3845C19.8288 16.1416 20.2092 16.2998 20.5255 16.6161C20.8418 16.9324 21 17.3128 21 17.7571V19.2761C21 19.7204 20.8418 20.1008 20.5255 20.4171C20.2092 20.7334 19.8288 20.8916 19.3845 20.8916H4.6155Z",
    fill: "#B30505"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSirenButton);
export default __webpack_public_path__ + "static/media/SirenButton.c0d6769f800f7651622384a28c4ec96a.svg";
export { ForwardRef as ReactComponent };